export default Object.freeze({
  Shared: 1,
  CompanyExclusive: 2,
  Internal: 3,
});
